import { T_HEADER_PAGE_CONSTANTS } from './TYPES'

const FR_HEADER_PAGE_CONSTANTS: T_HEADER_PAGE_CONSTANTS = {
  PROFILE_TEXT: 'Profil',
  LOGOUT_TEXT: 'Déconnexion'
}

export default FR_HEADER_PAGE_CONSTANTS
